<template>
  <div>
    <modal @close="onAccept">
      <h3 slot="header">{{ title }}</h3>
      <div slot="body">
        <slot name="body">
          <td v-html="htmlContent"></td>
        </slot>
      </div>
      <!-- Align vertically -->
      <div slot="footer" class="center-vertical">
        <btn-pill btn-size="s" @click="onAccept">{{ acceptButtonText() }}</btn-pill>
        <btn-pill v-if="knowMoreLink" btn-size="s" @click="onKnowMoreClick" :btnText="$t('menu.knowMore')" ></btn-pill>
      </div>
    </modal>
  </div>
</template>

<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import Modal from '@/components/shared/dialogs/Modal';

export default {
  name: 'InformationModal',
  components: {
    BtnPill,
    Modal
  },
  props: {
    title: {
      type: String
    },
    htmlContent: {
      type: String
    },
    acceptButton: {
      type: String
    },
    knowMoreLink: {
      type: String
    }
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  methods: {
    onAccept (event) {
      this.$emit('accept', event);
    },
    onKnowMoreClick (event) {
      // Redirect to the know more link
      window.open(this.knowMoreLink, '_blank');
    },
    acceptButtonText () {
      if (this.acceptButton === undefined) {
        return this.$t('commons.ok');
      }
      return this.acceptButton;
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 13:
        case 27:
          this.$emit('accept', event);
          break;
      }
    }
  }
};

</script>

<style lang="scss" scoped>
.center-vertical {
  display: flex;
  flex-direction: row; /* Horizontal alignment */
  justify-content: flex-start; /* Align items at the start */
  gap: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/dialogs/InformationModal.vue